import React, { useState, useEffect } from 'react';
import {
    Box, Paper, TextField, Typography, Tabs, Tab, Autocomplete,
    RadioGroup, FormControlLabel, Radio, Button, Checkbox, CircularProgress,
    List, ListItem, ListItemText, ListItemSecondaryAction, IconButton
} from '@mui/material'
import { DragIndicator as DragHandleIcon } from '@mui/icons-material';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { withTranslation } from 'react-i18next';
import { Colors } from '../../../Styles/Colors';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions';

const formatList = [
    { label: "A4 Portrait", value: "portrait_a4" },
]

const fontList = [
    { label: "Arial", value: "Arial" },
    { label: "Times New Roman", value: "TimesNewRoman" },
    { label: "Calibri", value: "Calibri" },
    { label: "Verdana", value: "Verdana" },
    { label: "Helvetica", value: "Helvetica" }
]

const fontSizeList = [7, 8, 9, 10, 11, 12];

const placementList = [
    { label: "Left", value: "left" },
    { label: "Right", value: "right" }
]

const templateList = [
    { label: "Template 1", value: "Template 1" },
    { label: "Template 2", value: "Template 2" },
]

const defaultTemplateData = {
    selectedTemplate: "Template 1",
    customTemplateName: ""
}

// Default services for drag and drop
const defaultServices = [
  { id: 'ip-service', name: 'IP-Service', order: 1, is_active: true },
  { id: 'laboratory', name: 'Laboratory', order: 2, is_active: true },
  { id: 'radiology', name: 'Radiology', order: 3, is_active: true },
  { id: 'investigations', name: 'Investigations', order: 4, is_active: true },
  { id: 'pharmacy', name: 'Pharmacy', order: 5, is_active: true },
]

// Default structures for initialization
const defaultContentPatient = [
    { id: 1, field_name: "name", system_name: "Name", custom_name: "Name", placement: "left", is_active: true, include_age: false },
    { id: 2, field_name: "age_gender", system_name: "Age/Gender", custom_name: "Age/Gender", placement: "left", is_active: true },
    { id: 3, field_name: "uhid", system_name: "UHID", custom_name: "UHID", placement: "left", is_active: true },
    { id: 4, field_name: "mobile_no", system_name: "Mobile No", custom_name: "Mobile No", placement: "left", is_active: true },
    { id: 5, field_name: "address", system_name: "Address", custom_name: "Address", placement: "left", is_active: true },
    { id: 6, field_name: "room_bed_no", system_name: "Room/Bed No", custom_name: "Room/Bed No", placement: "left", is_active: true },
    { id: 7, field_name: "ccn_number", system_name: "CCN Number", custom_name: "CCN Number", placement: "left", is_active: true },
    { id: 8, field_name: "barcode", system_name: "Barcode", custom_name: "Barcode", placement: "right", is_active: true },
    { id: 9, field_name: "tpa_name", system_name: "TPA Name", custom_name: "TPA Name", placement: "right", is_active: true },
    { id: 10, field_name: "insurance_name", system_name: "Insurance Name", custom_name: "Insurance Name", placement: "right", is_active: true },
    { id: 11, field_name: "corporate_name", system_name: "Corporate Name", custom_name: "Corporate Name", placement: "right", is_active: true },
    { id: 12, field_name: "invoice_date", system_name: "Invoice Date", custom_name: "Invoice Date", placement: "right", is_active: true },
    { id: 13, field_name: "invoice_number", system_name: "Invoice Number", custom_name: "Invoice Number", placement: "right", is_active: true },
    { id: 14, field_name: "ip_number", system_name: "IP Number", custom_name: "IP Number", placement: "right", is_active: true },
    { id: 15, field_name: "ip_admission_date", system_name: "IP Admission Date", custom_name: "IP Admission Date", placement: "right", is_active: true },
    { id: 16, field_name: "discharged_on", system_name: "Discharged On", custom_name: "Discharged On", placement: "right", is_active: true },
    { id: 17, field_name: "policy_number", system_name: "Policy Number", custom_name: "Policy Number", placement: "right", is_active: true },
    { id: 18, field_name: "visiting_consultant", system_name: "Visiting Consultant", custom_name: "Visiting Consultant", placement: "right", is_active: true },
    { id: 19, field_name: "visiting_consultant_2", system_name: "Visiting Consultant 2", custom_name: "Visiting Consultant 2", placement: "right", is_active: true },
    { id: 20, field_name: "visiting_consultant_3", system_name: "Visiting Consultant 3", custom_name: "Visiting Consultant 3", placement: "right", is_active: true },
    { id: 21, field_name: "visiting_consultant_4", system_name: "Visiting Consultant 4", custom_name: "Visiting Consultant 4", placement: "right", is_active: true },
    { id: 22, field_name: "doctor_name", system_name: "Doctor Name", custom_name: "Doctor Name", placement: "left", is_active: true }
]

// Updated default additional config to match backend structure
const defaultAdditionalConfig = {
    patient_details_in_lateral_pages: true,
    show_service_date: true,
    show_report_prepared_by: true,
    show_sub_total_row: true,
    show_receipt_description: true,
    show_receipt_in_separate_page: true,
    show_co_payment_option_for_insurance: true,
    show_require_terms_and_conditions: true,
    show_discharge_time: true,
    show_pharmacy_transactions_detailed_bill: true,
}

const keysHavingWidth = new Set(["doctor_name", "department", "date", "service_name", "service_type", "particulars", "txt_amt", "cgst", "cgst_percent", "cgst_amount", "sgst", "sgst_percent", "sgst_amount", "gst", "gst_percent", "gst_amount", "amount", "sub_total"]);
const disableContentFields = new Set(["barcode"]);

const PrintConfiguration = (props) => {
    const [titleName, setTitleName] = useState('')
    const [state, setState] = useState({
        previewUrl: "",
        previewLoader: false,
        tabValue: 'basic',
        basicData: {
            format: "portrait_a4",
            font: "Helvetica",
            fontSize: 10,
            margin_top: "0.5",
            margin_right: "0.5",
            margin_bottom: "0.5",
            margin_left: "0.5",
            header_space: "0",
            footer_space: "0",
            with_header: true,
            print_header_allpages: true,
            with_footer: true,
            print_footer_allpages: true,
        },
        validationBasicError: {
            margin_top: "",
            margin_right: "",
            margin_bottom: "",
            margin_left: "",
            header_space: "",
            footer_space: "",
        },
        content_patient: [],
        system_name:'',
        services: [...defaultServices],
        templateData: {
            selectedTemplate: "standard",
            customTemplateName: ""
        },
        additional_config: {},
        // Drag and drop state
        dragStartIndex: null,
        dragOverIndex: null,
        //toast msg state
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: "",
        isLoader: false,
    })
     let commonDisable = CheckAccessFunc("front_office", "Settings", "Layout Configuration", "IP Detailed Print Configuration", "SubTab")?.editAccess

    useEffect(() => {
        getLayoutData()
        getPreviewUrl()
    }, [])

    const updateState = (newState) => {
        setState((prevState) => ({
            ...prevState,
            ...newState
        }))
    }

    const findValue = (list = [], value) => {
        return list?.find(item => item.value === value) || null;
    }

    const toValidStr = (val, fallback = "0.5") => {
        return val != null ? String(val) : fallback;
    };

    const mergeWithDefault = (apiData, defaultData, isArray = true) => {
        if (!apiData) return isArray ? [...defaultData] : { ...defaultData };

        if (isArray) {
            return defaultData.map(defaultItem => {
                const apiItem = apiData.find(item => item.field_name === defaultItem.field_name);
                return apiItem ? { ...defaultItem, ...apiItem } : defaultItem;
            });
        } else {
            return { ...defaultData, ...apiData };
        }
    };

    const getLayoutData = () => {
        try {
            RestAPIService.GetWithoutReplica(Serviceurls.IP_PRINT_CONFIG)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const Data = response.data.data;

                        const mergedPatientDetails = Data?.header_details?.patient_details || [...defaultContentPatient];
                        const titleDetails = Data?.header_details?.title?.custom_name
                        const titleSystemName = Data?.header_details?.title?.system_name
                        let mergedServices = [...defaultServices];

                        if (Data?.content?.print_order && Data.content.print_order.length > 0) {

                            mergedServices = Data.content.print_order
                                .map(service => {
                                    return {
                                        id: service.field_name,
                                        name: service.system_name,
                                        order: service.id,
                                        is_active: service.is_active ?? true,
                                    };
                                })
                                .sort((a, b) => a.order - b.order);
                        }

                        const mergedTemplateData = {
                            selectedTemplate: Data?.content?.template_format || "Template 1",
                        };

                        const apiAdditionalConfig = Data?.custom_configuration || {};

                        const mergedAdditionalConfig = {
                            ...defaultAdditionalConfig,
                            ...apiAdditionalConfig
                        };

                        updateState({
                            basicData: {
                                format: Data?.basic_layout?.format || "portrait_a4",
                                font: Data?.basic_layout?.font || "Helvetica",
                                fontSize: Data?.basic_layout?.font_size || 10,
                                margin_top: toValidStr(Data?.basic_layout?.margin_top),
                                margin_right: toValidStr(Data?.basic_layout?.margin_right),
                                margin_bottom: toValidStr(Data?.basic_layout?.margin_bottom),
                                margin_left: toValidStr(Data?.basic_layout?.margin_left),
                                header_space: toValidStr(Data?.basic_layout?.header_space, "0"),
                                footer_space: toValidStr(Data?.basic_layout?.footer_space, "0"),
                                with_header: Data?.basic_layout?.with_header ?? true,
                                print_header_allpages: Data?.basic_layout?.print_header_allpages ?? true,
                                with_footer: Data?.basic_layout?.with_footer ?? true,
                                print_footer_allpages: Data?.basic_layout?.print_footer_allpages ?? true,
                            },
                            content_patient: mergedPatientDetails,
                            system_name:titleSystemName,
                            services: mergedServices,
                            templateData: mergedTemplateData,
                            additional_config: mergedAdditionalConfig
                        })
                        setTitleName(titleDetails)
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const postPrintDetails = () => {
        const loginInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        const Title = titleName.trim()

        try {
            const transformedServices = state.services.map((service, index) => ({
                id: index + 1,
                field_name: service.id,
                system_name: service.name,
                is_active: service.is_active,
            }));

            if(Title.length === 0 || Title === ""){
                errorMessage('Enter the Title Name')
                return updateState({ isLoader: false });
            }

            const data = {
                clinic_id: loginInfo?.clinic_id || null,
                basic_layout: {
                    format: state.basicData.format || "portrait_a4",
                    font: state.basicData.font || "Helvetica",
                    font_size: state.basicData.fontSize || 10,
                    margin_top: toValidNumber(state.basicData.margin_top),
                    margin_right: toValidNumber(state.basicData.margin_right),
                    margin_bottom: toValidNumber(state.basicData.margin_bottom),
                    margin_left: toValidNumber(state.basicData.margin_left),
                    header_space: toValidNumber(state.basicData.header_space, 0),
                    footer_space: toValidNumber(state.basicData.footer_space, 0),
                    with_header: state.basicData.with_header ?? true,
                    print_header_allpages: state.basicData.print_header_allpages ?? true,
                    with_footer: state.basicData.with_footer ?? true,
                    print_footer_allpages: state.basicData.print_footer_allpages ?? true,
                },
                header_details: {
                    patient_details: state.content_patient,
                    title: {
                        "field_name": "title",
                        "system_name": state.system_name,
                        "custom_name": Title.trim(),
                    }

                },
                content: {
                    template_format: state.templateData.selectedTemplate,
                    print_order: transformedServices,
                },
                custom_configuration: state.additional_config
            }

            RestAPIService.create(data, Serviceurls.IP_PRINT_CONFIG)
                .then((response) => {
                    if (response.data.status === "success") {
                        successMessage(response.data.message);
                        updateState({ isLoader: false });
                        getLayoutData();
                        getPreviewUrl();
                    }
                }).catch((error) => {
                    errorMessage(error.response.data.message || error.message)
                    updateState({ isLoader: false });
                })
        }
        catch (e) {
            errorMessage(e.message)
            updateState({ isLoader: false });
        }
    }

    const getPreviewUrl = () => {
        const loginInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        try {
            updateState({ previewUrl: "", previewLoader: true })
            RestAPIService.GetWithoutReplica(`${Serviceurls.IP_PRINT_CONFIG_PREVIEW}?preview=true`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    updateState({
                        previewUrl: fileURL,
                        previewLoader: false
                    })
                }).catch((e) => {
                    updateState({ previewLoader: false })
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            updateState({ previewLoader: false })
            errorMessage(e?.response?.data?.message || e.message)
        }
    }

    const successMessage = (message) => {
        updateState({
            successMsg: true,
            successMsgText: message
        })
    }
    const errorMessage = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ""
        })
    }

    const resetPrintDetails = () => {
        updateState({
            basicData: {
                format: "portrait_a4",
                font: "Helvetica",
                fontSize: 10,
                margin_top: "0.5",
                margin_right: "0.5",
                margin_bottom: "0.5",
                margin_left: "0.5",
                header_space: "0",
                footer_space: "0",
                with_header: true,
                print_header_allpages: true,
                with_footer: true,
                print_footer_allpages: true,
            },
            validationBasicError: {
                margin_top: "",
                margin_right: "",
                margin_bottom: "",
                margin_left: "",
            },
            content_patient: [...defaultContentPatient],
            system_name:'INPATIENT INVOICE - DETAILED BILL',
            services: [...defaultServices],
            templateData: { ...defaultTemplateData },
            additional_config: { ...defaultAdditionalConfig },
            isLoader: false,
        })
        setTitleName("INPATIENT INVOICE - DETAILED BILL")
    }

    const handleDragStart = (index) => {
        updateState({ dragStartIndex: index });
    };

    const handleDragOver = (index) => {
        updateState({ dragOverIndex: index });
    };

    const handleDragEnd = () => {
        const { dragStartIndex, dragOverIndex } = state;

        if (dragStartIndex === null || dragOverIndex === null || dragStartIndex === dragOverIndex) {
            updateState({ dragStartIndex: null, dragOverIndex: null });
            return;
        }

        const items = Array.from(state.services);
        const [reorderedItem] = items.splice(dragStartIndex, 1);
        items.splice(dragOverIndex, 0, reorderedItem);

        const updatedItems = items.map((item, index) => ({
            ...item,
            order: index + 1
        }));

        updateState({
            services: updatedItems,
            dragStartIndex: null,
            dragOverIndex: null
        });
    };

    const handleTemplateChange = (key, value) => {
        updateState({
            templateData: {
                ...state.templateData,
                [key]: value
            }
        });
    };

    const handleServiceChange = (id, field, value) => {
        const updatedServices = state.services.map(service =>
            service.id === id ? { ...service, [field]: value } : service
        );
        updateState({ services: updatedServices });
    };

    const validateItem = () => {
        const { basicData } = state;

        const errors = {};

        const fields = [
            { key: "margin_top", label: "Margin Top" },
            { key: "margin_right", label: "Margin Right" },
            { key: "margin_bottom", label: "Margin Bottom" },
            { key: "margin_left", label: "Margin Left" },
        ];

        for (const { key, label } of fields) {
            const value = basicData?.[key];
            if (value === "") {
                errors[key] = `${label} is required.`;
            } else {
                const num = parseFloat(value);
                if (isNaN(num) || num < 0 || num > 4) {
                    errors[key] = `${label} must be between 0 and 4.`;
                }
            }
        }

        const top = parseFloat(basicData.margin_top) || 0;
        const bottom = parseFloat(basicData.margin_bottom) || 0;
        const left = parseFloat(basicData.margin_left) || 0;
        const right = parseFloat(basicData.margin_right) || 0;

        if (top + bottom > 4) {
            errors.margin_top = "Sum of Top and Bottom margins should not exceed 4cm";
            errors.margin_bottom = "Sum of Top and Bottom margins should not exceed 4cm";
        }

        if (left + right > 4) {
            errors.margin_left = "Sum of Left and Right margins should not exceed 4cm";
            errors.margin_right = "Sum of Left and Right margins should not exceed 4cm";
        }

        // Header/Footer space validation
        if (basicData.header_space !== "" && basicData.header_space !== "0") {
            const num = parseFloat(basicData.header_space);
            if (isNaN(num) || num < 0 || num > 10) {
                errors.header_space = "Header space must be between 0 and 10cm.";
            }
        }

        if (basicData.footer_space !== "" && basicData.footer_space !== "0") {
            const num = parseFloat(basicData.footer_space);
            if (isNaN(num) || num < 0 || num > 5) {
                errors.footer_space = "Footer space must be between 0 and 5cm.";
            }
        }

        updateState({
            validationBasicError: {
                ...state.validationBasicError,
                ...errors,
            },
        });

        return Object.values(errors).every(msg => !msg);
    };

    const validateData = (label, content) => {
        if (!content || content.length === 0) return `${label} data is not available`;

        const missingCustomName = content.some(item => !item.custom_name?.trim());
        if (missingCustomName) {
            return `${label} Custom name is required for all fields.`;
        }

        const activeFields = content?.filter(item => item.is_active);
        if (activeFields?.length === 0) {
            return `${label} Atleast one field must be active.`;
        }

        return "";
    };

    const validationData = () => {
        updateState({ isLoader: true });
        const validMsg = validateItem() ? "" : "Please fill all the required fields in Basic Layout";
        const validPatientMsg = validateData("Patient details", state.content_patient);

        const errorMsg = validMsg || validPatientMsg;
        if (errorMsg === "") {
            postPrintDetails();
        } else {
            updateState({
                isLoader: false,
                isErrorMsg: true,
                isErrorMsgText: errorMsg
            });
        }
    }

    const toValidNumber = (val, fallback = 0.5) => {
        const num = parseFloat(val);
        return isNaN(num) ? fallback : num;
    };


    const handleBasicDataChange = (key, value) => {
        if (["margin_top", "margin_right", "margin_bottom", "margin_left", "header_space", "footer_space"].includes(key)) {
            if (value === "") {
                updateState({
                    basicData: {
                        ...state.basicData,
                        [key]: value
                    },
                    validationBasicError: {
                        ...state.validationBasicError,
                        [key]: ""
                    }
                });
                return;
            }

            const decimalRegex = /^\d*\.?\d*$/;

            if (!decimalRegex.test(value)) {
                return;
            }

            const decimalCount = (value.match(/\./g) || []).length;
            if (decimalCount > 1) {
                return;
            }

            let processedValue = value;
            if (value.includes('.')) {
                const parts = value.split('.');
                if (parts[1] && parts[1].length > 2) {
                    processedValue = parts[0] + '.' + parts[1].substring(0, 2);
                }
            }

            const num = parseFloat(processedValue);
            if (key === "header_space" && !isNaN(num) && num > 10) {
                return;
            }
            if (key === "footer_space" && !isNaN(num) && num > 5) {
            return;
            }
            let errorMessage = "";

            switch (key) {
                case "margin_top":
                case "margin_right":
                case "margin_bottom":
                case "margin_left":
                    if (!isNaN(num) && num >= 0 && num <= 4) {
                        let updatedBasicData = { ...state.basicData, [key]: processedValue };
                        let validationErrors = { ...state.validationBasicError };

                        validationErrors[key] = "";

                        const top = parseFloat(updatedBasicData.margin_top) || 0;
                        const bottom = parseFloat(updatedBasicData.margin_bottom) || 0;
                        const left = parseFloat(updatedBasicData.margin_left) || 0;
                        const right = parseFloat(updatedBasicData.margin_right) || 0;

                        if (top + bottom > 4) {
                            const sumError = "Sum of Top and Bottom margins should not exceed 4cm";
                            validationErrors.margin_top = sumError;
                            validationErrors.margin_bottom = sumError;
                        } else {
                            if (validationErrors.margin_top === "Sum of Top and Bottom margins should not exceed 4cm") {
                                validationErrors.margin_top = "";
                            }
                            if (validationErrors.margin_bottom === "Sum of Top and Bottom margins should not exceed 4cm") {
                                validationErrors.margin_bottom = "";
                            }
                        }

                        if (left + right > 4) {
                            const sumError = "Sum of Left and Right margins should not exceed 4cm";
                            validationErrors.margin_left = sumError;
                            validationErrors.margin_right = sumError;
                        } else {
                            if (validationErrors.margin_left === "Sum of Left and Right margins should not exceed 4cm") {
                                validationErrors.margin_left = "";
                            }
                            if (validationErrors.margin_right === "Sum of Left and Right margins should not exceed 4cm") {
                                validationErrors.margin_right = "";
                            }
                        }

                        if (!validationErrors[key] && num < 0.5 && num !== 0) {
                            validationErrors[key] = "Value should be greater than or equal to 0.5";
                        }

                        updateState({
                            basicData: updatedBasicData,
                            validationBasicError: validationErrors
                        });
                    } else if (value === "0") {
                        updateState({
                            basicData: {
                                ...state.basicData,
                                [key]: processedValue
                            },
                            validationBasicError: {
                                ...state.validationBasicError,
                                [key]: ""
                            }
                        });
                    } else if (!isNaN(num) && (num < 0 || num > 4)) {
                        updateState({
                            basicData: {
                                ...state.basicData,
                                [key]: processedValue
                            },
                            validationBasicError: {
                                ...state.validationBasicError,
                                [key]: "Value must be between 0 and 4cm"
                            }
                        });
                    }
                    break;
                case "header_space":
                    if (processedValue === "" || processedValue === "0") {
                        updateState({
                            basicData: {
                                ...state.basicData,
                                [key]: processedValue
                            },
                            validationBasicError: {
                                ...state.validationBasicError,
                                [key]: ""
                            }
                        });
                    } else if (!isNaN(num) && num >= 0 && num <= 10) {
                        updateState({
                            basicData: {
                                ...state.basicData,
                                [key]: processedValue
                            },
                            validationBasicError: {
                                ...state.validationBasicError,
                                [key]: ""
                            }
                        });
                    } else {
                        updateState({
                            basicData: {
                                ...state.basicData,
                                [key]: processedValue
                            },
                            validationBasicError: {
                                ...state.validationBasicError,
                                [key]: "Value must be between 0 and 10cm"
                            }
                        });
                    }
                    break;
                case "footer_space":
                    if (processedValue === "" || processedValue === "0") {
                        updateState({
                            basicData: {
                                ...state.basicData,
                                [key]: processedValue
                            },
                            validationBasicError: {
                                ...state.validationBasicError,
                                [key]: ""
                            }
                        });
                    } else if (!isNaN(num) && num >= 0 && num <= 5) {
                        updateState({
                            basicData: {
                                ...state.basicData,
                                [key]: processedValue
                            },
                            validationBasicError: {
                                ...state.validationBasicError,
                                [key]: ""
                            }
                        });
                    } else {
                        updateState({
                            basicData: {
                                ...state.basicData,
                                [key]: processedValue
                            },
                            validationBasicError: {
                                ...state.validationBasicError,
                                [key]: "Value must be between 0 and 5cm"
                            }
                        });
                    }
                    break;
            }
        } else {
            updateState({
                basicData: {
                    ...state.basicData,
                    [key]: value,
                }
            });
        }
    };

    const handleContentChange = (sectionKey, field_name, updateKey, value) => {
        const updatedContent = state?.[sectionKey]?.map((item) => {
            if (item.field_name === field_name) {
                if (field_name === "name" && updateKey === "include_age") {
                    const updatedItems = state[sectionKey].map(contentItem => {
                        if (contentItem.field_name === "age_gender") {
                            return {
                                ...contentItem,
                                is_active: !value
                            };
                        }
                        return contentItem;
                    });
                    updateState({ [sectionKey]: updatedItems });
                }

                if (updateKey === "is_active") {
                    const shouldClearWidth = !value && keysHavingWidth.has(item.field_name);
                    return {
                        ...item,
                        is_active: value,
                        ...(shouldClearWidth && { width: 0 })
                    };
                } else if (updateKey === "width") {
                    const val = CommonValidation.numberOnly(value);
                    if ((val && +value >= 0 && +value <= 100) || value === '') {
                        return { ...item, [updateKey]: +value };
                    }
                    return item;
                }
                return { ...item, [updateKey]: value };
            }
            return item;
        });

        updateState({ [sectionKey]: updatedContent });
    };

    const handleAdditionalConfigChange = (key, value) => {
        if (key === 'show_pharmacy_transactions_detailed_bill' &&
            state.additional_config.disable_show_pharmacy_transactions_detailed_bill === true) {
            return;
        }
        const updatedConfig = {
            ...state.additional_config,
            [key]: value
        };
        updateState({
            additional_config: updatedConfig
        });
    };

    const renderAutoComplete = (label, statekey, value, list = [], showKey, handleChange, isDisable = false, width) => {
        return (
            <Box>
                {label && <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>{label}</Typography>}
                <Autocomplete
                    size="small"
                    options={list || []}
                    getOptionLabel={(option) => (typeof option === "string" ? option : option?.[showKey] ? option[showKey] || "" : JSON.stringify(option))}
                    value={statekey === "fontSize" ? value : findValue(list, value) || null}
                    disabled={isDisable}
                    disableClearable
                    onChange={(event, newValue) => { handleChange(statekey, newValue) }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            sx={{ width: width ? width : "100%" }}
                            size='small'
                            label={label}
                            autoComplete="off"
                            inputProps={{
                                ...params.inputProps,
                            }}
                        />
                    )}
                />
            </Box>
        );
    };

    const renderTextField = (label = "", name, value, showHelper = false, handleChange,isDisabled = false) => {
        const handleInputChange = (e) => {
             if (isDisabled) return; 
            let inputValue = e.target.value;

            if (inputValue === "") {
                (handleChange || handleBasicDataChange)(name, inputValue);
                return;
            }

            const decimalRegex = /^\d*\.?\d*$/;

            if (decimalRegex.test(inputValue)) {
                const decimalCount = (inputValue.match(/\./g) || []).length;
                if (decimalCount <= 1) {
                    if (inputValue.includes('.')) {
                        const parts = inputValue.split('.');
                        if (parts[1] && parts[1].length > 2) {
                            inputValue = parts[0] + '.' + parts[1].substring(0, 2);
                        }
                    }
                    const num = parseFloat(inputValue);
                    if (name === "header_space" && !isNaN(num) && num > 10) {
                        return; 
                    }
                    if (name === "footer_space" && !isNaN(num) && num > 5) {
                        return; 
                    }
                    (handleChange || handleBasicDataChange)(name, inputValue);
                }
            }
        };

        return (
            <Box sx={{ width: handleChange ? "100%" : "40%", display: "flex", alignItems: "center", marginY: "0.5vw" }}>
                {label && <Typography fontWeight={600} fontSize={"0.8vw"} flex={0.4}>{label}</Typography>}
                <TextField
                    size='small'
                    sx={{ flex: (handleChange || label === "") ? 1 : 0.6 }}
                    autoComplete='off'
                    disabled={isDisabled}
                    value={value || ""}
                    inputProps={{
                        maxLength: 4,
                        inputMode: 'decimal',
                        ...((name === "header_space" || name === "footer_space") && {
                            min: 0,
                            max: 2,
                            step: 0.1
                        })
                    }}
                    onChange={handleInputChange}
                    // onKeyPress={handleKeyPress}
                    onPaste={(e) => {
                        const pasteData = e.clipboardData.getData('text');
                        const num = parseFloat(pasteData);
                        if (name === "header_space" && !isNaN(num) && num > 10) {
                            e.preventDefault();
                        }
                        if (name === "footer_space" && !isNaN(num) && num > 5) {
                            e.preventDefault();
                        }
                    }}
                    InputProps={{
                        endAdornment: <Typography>{handleChange ? "" : showHelper ? "px" : "cm"}</Typography>,
                        emed_tid: `Field_${name}`
                    }}
                    helperText={
                        state.validationBasicError[name] ||
                        (name === "header_space" ? "0 - 10cm" :
                        name === "footer_space" ? "0 - 5cm" :
                        ["margin_top", "margin_bottom", "margin_left", "margin_right"]?.includes(name) && !state.validationBasicError[name]
                            ? "0 - 4cm"
                            : "")
                    }
                    error={Boolean(state.validationBasicError[name])}
                />
            </Box>
        )
    }

    const renderContentTextField = (sectionKey, field_name, stateKey, idx, isDisable = false) => {
        const sectionData = state[sectionKey];
        if (!sectionData || !sectionData[idx]) return null;

        return (
            <TextField
                size='small'
                fullWidth
                disabled={isDisable}
                autoComplete='off'
                value={sectionData[idx][stateKey] || ""}
                inputProps={{ maxLength: 25 }}
                onChange={(e) => { handleContentChange(sectionKey, field_name, stateKey, e.target.value) }}
                InputProps={{
                    emed_tid: `Field_${stateKey}`,
                }}
            />
        )
    }

    const renderButton = (label, variant, onClick) => {
        return (<Button
            emed_tid={`print_${label}`}
            disabled={state?.isLoader || !commonDisable}
            variant={variant}
            size="small"
            id="eMed_Config_btn"
            sx={{ width: "10vw" }}
            onClick={() => { onClick() }} >
            {label}
        </Button>)
    }

    const renderRadioBtn = (label, value, checked, stateKey) => {
        return (
            <FormControlLabel control={
                <Radio size='small'
                    checked={checked}
                    value={value}
                    onChange={(e) => { handleBasicDataChange(stateKey, e.target.value) }}
                />}
                label={label} />
        )
    }

    const renderCheckbox = (label, stateKey, value, handleChange, isDisable = false) => {
        const changeHandler = handleChange || handleBasicDataChange;
        return (
            <FormControlLabel
                control={<Checkbox
                    disabled={isDisable}
                    checked={value || false}
                    onChange={(e) => { changeHandler(stateKey, e.target.checked) }}
                    size='small' />}
                label={<Typography fontSize={'0.9vw'} fontWeight={600}>
                    {label}
                </Typography>} />
        )
    }

    const renderHeadFooter = (text1, text2) => {
        return (
            <Box sx={{ width: "80%", display: "flex", alignItems: "center", marginY: "0.5vw" }}>
                <Typography fontSize={"0.8vw"} mb={"0.3vw"} flex={0.4} color={"#8a8585"}>{text1}</Typography>
                <Typography fontSize={"0.8vw"} mb={"0.3vw"} flex={0.6} color={"#8a8585"}>{text2}</Typography>
            </Box>
        )
    }

    const renderHeaderRow = (leftContent, rightContent) => {
        return (<Box sx={{ width: "80%", display: "flex", alignItems: "center", marginY: "0.5vw" }}>
            <Box sx={{ flex: 0.4 }}>{leftContent}</Box>
            <Box sx={{ flex: 0.6 }}>{rightContent}</Box>
        </Box>)
    }

    const renderBasicLayout = () => {
        return (
            <Box sx={{ width: "100%", height: "100%" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "0.5vw", borderBottom: "1px solid lightGray", padding: "0.625vw" }}>
                    {renderAutoComplete("Format", "format", state.basicData.format, formatList, "label", (key, value) => { handleBasicDataChange(key, value?.value) }, true, "14vw")}
                    {renderAutoComplete("Font", "font", state.basicData.font, fontList, "label", (key, value) => { handleBasicDataChange(key, value?.value) }, false, "14vw")}
                    {renderAutoComplete("Font Size", "fontSize", state.basicData.fontSize, fontSizeList, "", (key, value) => { handleBasicDataChange(key, value) }, false, "14vw")}
                </Box>
                <Box marginY={"0.5vw"} sx={{ borderBottom: "1px solid lightGray", padding: "0.625vw" }}>
                    <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>MARGIN SETUP</Typography>
                    <Typography fontSize={"0.8vw"} mb={"0.3vw"} color={"#8a8585"}>Settings</Typography>
                    {renderTextField("Top", "margin_top", state.basicData.margin_top)}
                    {renderTextField("Bottom", "margin_bottom", state.basicData.margin_bottom)}
                    {renderTextField("Left", "margin_left", state.basicData.margin_left)}
                    {renderTextField("Right", "margin_right", state.basicData.margin_right)}
                </Box>
                <Box marginY={"0.5vw"} sx={{ padding: "0.625vw" }}>
                    <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>HEADER AND FOOTER</Typography>
                    {/* Header */}
                    {renderHeadFooter("Header", "Spacing Height")}
                    {renderHeaderRow(
                        renderCheckbox("Without Header", "with_header", !state.basicData.with_header, (key, value) => handleBasicDataChange("with_header", !value)),
                        renderTextField("", "header_space", state.basicData.header_space, false, null, state.basicData.with_header)
                    )}
                    {renderHeaderRow(
                        renderCheckbox("With Header", "with_header", state.basicData.with_header),
                        renderCheckbox("Print Header In All Pages", "print_header_allpages", state.basicData.print_header_allpages, null, !state.basicData.with_header)
                    )}
                    {/* Footer */}
                    {renderHeadFooter("Footer", "Spacing Height")}
                    {renderHeaderRow(
                        renderCheckbox("Without Footer", "with_footer", !state.basicData.with_footer, (key, value) => handleBasicDataChange("with_footer", !value)),
                        renderTextField("", "footer_space", state.basicData.footer_space, false, null, state.basicData.with_footer)
                    )}
                    {renderHeaderRow(
                        renderCheckbox("With Footer", "with_footer", state.basicData.with_footer),
                        renderCheckbox("Print Footer In All Pages", "print_footer_allpages", state.basicData.print_footer_allpages, null, !state.basicData.with_footer)
                    )}
                </Box>
            </Box>
        )
    }

    const renderAlignHeader = (showWidth = false) => {
        return (
            <Box sx={{ display: "grid", gridTemplateColumns: showWidth ? "repeat(4, 1fr)" : "repeat(3, 1fr)", marginY: "0.5vw", columnGap: "0.5vw" }}>
                {["System Name", "Custom Name", "Placement", ...(showWidth ? ["Width"] : [])]?.map((label, index) => (
                    <Typography
                        key={index}
                        fontSize="0.8vw"
                        mb="0.3vw"
                        color="#8a8585"
                    >
                        {label}
                    </Typography>
                ))}
            </Box>
        )
    }

    const renderContentSection = (title, sectionKey, showWidth = false) => {
        const sectionData = state[sectionKey];
        if (!sectionData || sectionData.length === 0) {
            return (
                <Box marginY={"0.5vw"} sx={{ borderBottom: "1px solid lightGray", padding: "0.625vw" }}>
                    <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>{title}</Typography>
                    <Typography fontSize={"0.8vw"} color={"#8a8585"}>No data available</Typography>
                </Box>
            );
        }

        return (
            <Box marginY={"0.5vw"} sx={{ borderBottom: "1px solid lightGray", padding: "0.625vw" }}>
                <Box>
                    <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>Title</Typography>
                    <Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: "repeat(2, 0.336fr)" }}>
                            <Typography fontSize={"0.8vw"} mb={"0.3vw"}>System Name</Typography>
                            <Typography fontSize={"0.8vw"} mb={"0.3vw"}>Custom Name</Typography>
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: "repeat(2, 0.336fr)", alignItems: 'center' }}>
                            <Box sx={{ width: '14vw' }}>
                                <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}> {state.system_name} </Typography>
                            </Box>
                            <TextField
                                size='small'
                                fullWidth
                                sx={{ width: '28.5vw' }}
                                autoComplete='off'
                                placeholder='Enter Title Name'
                                value={titleName}
                                onChange={(e) => {
                                    setTitleName(e.target.value)
                                }}
                                inputProps={{ maxLength: 36 }}
                            />
                        </Box>

                    </Box>
                </Box>
                <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>{title}</Typography>
                {renderAlignHeader(showWidth)}
                {
                    sectionData?.map((item, index) => {
                        const isAgeGender = item.field_name === "age_gender";
                        const isNameField = item.field_name === "name";
                        const isBarcode = item.field_name === "barcode";
                        const nameField = sectionData.find(field => field.field_name === "name");
                        const shouldDisableAgeGender = nameField?.include_age || false;

                        const isFieldDisabled = disableContentFields.has(item.field_name);

                        return (
                            <Box sx={{
                                display: "grid",
                                gridTemplateColumns: showWidth ? "repeat(4, 1fr)" : "repeat(3, 1fr)",
                                marginY: "0.5vw",
                                columnGap: "0.5vw",
                                alignItems: "center"
                            }} key={`${item.field_name}_${item.id}`}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: "0.5vw" }}>
                                    <FormControlLabel
                                        control={<Checkbox
                                            id={item.id}
                                            checked={item.is_active || false}
                                            onChange={(e) => { handleContentChange(sectionKey, item.field_name, "is_active", e.target.checked) }}
                                            size='small'
                                            disabled={(isAgeGender && shouldDisableAgeGender)}
                                        />}
                                        label={<Typography fontSize={'0.9vw'} fontWeight={600} color={(isAgeGender && shouldDisableAgeGender) ? "#ccc" : Colors.SecondaryText}>
                                            {item.system_name}
                                        </Typography>} />

                                    {/* Separate Age/Gender Checkbox for Name field */}
                                    {isNameField && (
                                        <FormControlLabel
                                            control={<Checkbox
                                                checked={item.include_age || false}
                                                onChange={(e) => { handleContentChange(sectionKey, item.field_name, "include_age", e.target.checked) }}
                                                size='small'
                                            />}
                                            label={<Typography fontSize={'0.7vw'} color={Colors.SecondaryText}>
                                                Include Age
                                            </Typography>}
                                        />
                                    )}
                                </Box>

                                {renderContentTextField(sectionKey, item.field_name, "custom_name", index,
                                    (isAgeGender && shouldDisableAgeGender) || isFieldDisabled)}

                                {renderAutoComplete("", "alignment",
                                    item.placement || "left", placementList, "label",
                                    (key, value) => { handleContentChange(sectionKey, item.field_name, "placement", value?.value) },
                                    (isAgeGender && shouldDisableAgeGender))}

                                {showWidth && keysHavingWidth.has(item.field_name) &&
                                    renderContentTextField(sectionKey, item.field_name, "width", index,
                                        !item.is_active || (isAgeGender && shouldDisableAgeGender) || isFieldDisabled)}
                            </Box>
                        )
                    })
                }
            </Box>
        )
    }

    const renderContentLayout = () => {
        return (
            <Box sx={{ width: "100%", height: "100%", padding: "0.625vw" }}>
                {renderContentSection("Patient Details", "content_patient")}
            </Box>
        )
    }

    const renderTemplateLayout = () => {
        return (
            <Box sx={{ width: "100%", height: "100%", padding: "0.625vw" }}>
                {/* Template Selection Section */}
                <Box marginY={"0.5vw"} sx={{ borderBottom: "1px solid lightGray", padding: "0.625vw" }}>
                    <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>SELECT TEMPLATE</Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "1vw", marginY: "1vw" }}>
                        <Typography fontWeight={600} fontSize={"0.8vw"} flex={0.2}>Format</Typography>
                        {renderAutoComplete("", "selectedTemplate", state.templateData.selectedTemplate, templateList, "label",
                            (key, value) => handleTemplateChange(key, value?.value), false, "20vw")}
                    </Box>

                    {/* Custom Template Name Field */}
                    {state.templateData.selectedTemplate === "custom" && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: "1vw", marginY: "1vw" }}>
                            <Typography fontWeight={600} fontSize={"0.8vw"} flex={0.2}>Custom Name</Typography>
                            <TextField
                                size='small'
                                sx={{ flex: 0.8 }}
                                autoComplete='off'
                                value={state.templateData.customTemplateName || ""}
                                onChange={(e) => handleTemplateChange("customTemplateName", e.target.value)}
                                placeholder="Enter custom template name"
                            />
                        </Box>
                    )}
                </Box>

                {/* Drag and Drop Section */}
                <Box marginY={"0.5vw"} sx={{ padding: "0.625vw" }}>
                    <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>DRAG AND CHANGE THE PRINT ORDER</Typography>

                    <List sx={{ marginTop: "1vw" }}>
                        {state.services.map((service, index) => (
                            <ListItem
                                key={service.id}
                                sx={{
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    marginBottom: '0.5vw',
                                    backgroundColor: '#f5f5f5',
                                    cursor: 'grab',
                                    '&:hover': {
                                        backgroundColor: '#e9e9e9'
                                    },
                                    ...(state.dragStartIndex === index && {
                                        opacity: 0.5,
                                    }),
                                    ...(state.dragOverIndex === index && {
                                        borderColor: Colors.primary,
                                        backgroundColor: '#e3f2fd'
                                    })
                                }}
                                draggable
                                onDragStart={() => handleDragStart(index)}
                                onDragOver={(e) => {
                                    e.preventDefault();
                                    handleDragOver(index);
                                }}
                                onDragEnd={handleDragEnd}
                                onDrop={(e) => e.preventDefault()}
                            >
                                
                                <DragHandleIcon
                                    sx={{
                                        marginRight: '1vw',
                                        color: '#666',
                                        cursor: 'grab'
                                    }}
                                />
                                <Checkbox
                                    checked={service.is_active}
                                    onChange={(e) => {
                                        const updatedServices = [...state.services];
                                        updatedServices[index].is_active = e.target.checked;
                                        updateState({ services: updatedServices });
                                    }}
                                />
                                <ListItemText
                                    primary={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '1vw' }}>
                                            {/* <Typography sx={{
                                                fontWeight: 600,
                                                color: '#666',
                                                minWidth: '2vw'
                                            }}>
                                                {index + 1}.
                                            </Typography> */}
                                            <Typography sx={{ flex: 1 }}>
                                                {service.name}
                                            </Typography>
                                        </Box>
                                    }
                                />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Box>
        )
    }


    const renderAdditionalLayout = () => {
        const additionalConfig = state.additional_config || {};

        return (
            <Box sx={{
                width: "100%", height: "100%", padding: "0.625vw", display: "flex",
                flexDirection: "column",
                gap: "0.5vw",
            }}>

                {Object.keys(defaultAdditionalConfig)
                    .filter(key => key !== 'disable_show_pharmacy_transactions_detailed_bill')
                    .map((key) => {
                        const label = key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

                        const isPharmacyTransactions = (key === 'show_pharmacy_transactions_detailed_bill');
                        const isDisabled = isPharmacyTransactions && additionalConfig.disable_show_pharmacy_transactions_detailed_bill === true;

                        return (
                            <Box key={key} width={"100%"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                {renderCheckbox(
                                    label,
                                    key,
                                    additionalConfig[key],
                                    (_, value) => handleAdditionalConfigChange(key, value),
                                    isDisabled
                                )}
                            </Box>
                        )
                    })}
            </Box>
        )
    }
    const renderTabContent = (tabValue) => {
        switch (tabValue) {
            case 'basic':
                return renderBasicLayout();
            case 'content':
                return renderContentLayout();
            case 'template':
                return renderTemplateLayout();
            case 'additional':
                return renderAdditionalLayout();
            default:
                return null;
        }
    }
    return (
        <Box sx={{ height: "78.5vh" }}>
            <Box className='eMed_printDiv' sx={{ display: "flex", gap: "1vw", height: "100%" }}>
                <Paper elevation={2} sx={{ flex: 1 }}>
                    <Typography className='eMed_refdoc_title' sx={{ padding: "0.625vw", borderBottom: "1px solid lightGray" }}>
                        {"Print Preview"}
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "calc(100% - 3.5vw)", overflowY: "auto" }}>
                        {state.previewLoader ?
                            <CircularProgress color="primary" size={"2vw"} />
                            : state.previewUrl ? <iframe
                                style={{
                                    width: "100%",
                                    height: "100%",
                                }}
                                src={`${state.previewUrl}#toolbar=1&navpanes=0`}
                                type="application/pdf" />
                                : <Typography fontSize={"1vw"}>No Records to be shown</Typography>}
                    </Box>
                </Paper>
                <Paper elevation={2} sx={{ flex: 1 }}>
                    <Tabs
                        value={state.tabValue}
                        onChange={(e, newValue) => { updateState({ tabValue: newValue }) }}
                        sx={{ backgroundColor: Colors.DataTblHeaderbg, height: "6vh" }}
                    >
                        <Tab value={'basic'} label='Basic Layout' className='eMed_tab_header' />
                        <Tab value={'content'} label='Header Details' className='eMed_tab_header' />
                        <Tab value={'template'} label='Content' className='eMed_tab_header' />
                        <Tab value={'additional'} label='Custom Configuration' className='eMed_tab_header' />
                    </Tabs>
                    <Box sx={{ height: "calc(100% - 12vh)", overflowY: "auto", padding: "0.5vw" }}>
                        {renderTabContent(state.tabValue)}
                    </Box>
                    <Box sx={{
                        width: "100%", display: "flex", justifyContent: "flex-end",
                        alignItems: "center", height: "6vh", gap: "0.5vw",
                        backgroundColor: Colors.DataTblHeaderbg, paddingRight: "0.625vw"
                    }}>
                        {renderButton("Reset", 'outlined', resetPrintDetails)}
                        {renderButton("Save", 'contained', validationData)}
                    </Box>
                </Paper>
            </Box>
            {state.isErrorMsg && <ToastMsg severity={"error"} msg={state.isErrorMsgText} msgPop={msgClose.bind(this)} />}
            {state.successMsg && <ToastMsg severity={"success"} msg={state.successMsgText} msgPop={msgClose.bind(this)} />}
        </Box>
    )
}

export default withTranslation()(PrintConfiguration)